// Yellow theme - basic with light/dark support
const yellow = {
  id: 'yellow',
  name: 'Keltainen',
  price: 25,
  main: '#d4a017',
  light: '#f0c040',
  dark: '#b8860b',
  bg: '#fffde7',
  darkBg: '#2d2a17',
  isSuper: false,
  isDarkTheme: false,
  shape: 'pill',
  surfaces: {
    // Light mode
    lightBg: '#fff8c4',
    lightPaper: '#fffde7',
    lightContainer: '#fffde7',
    lightOnSurface: '#1a1a2e',
    lightOnSurfaceVariant: '#6b5e2e',
    lightOutline: '#9e8c4a',
    // Dark mode
    containerLowest: '#2d2a17',
    containerLow: '#1f1c0f',
    container: '#2d2a17',
    containerHigh: '#3d3820',
    containerHighest: '#4d462a',
    bright: '#5d5434',
    onSurface: '#f5efc8',
    onSurfaceVariant: '#c8b870',
    outline: '#9e8c4a',
    outlineVariant: '#5d5434',
    // Button colors — primary
    primaryContainer: '#d4a017',
    onPrimaryContainer: '#2d2000',
    primaryText: '#fffde7',
    primaryTextLight: '#fffde7',
    // Button colors — secondary (outlined)
    secondaryContainer: '#3d3200',
    onSecondaryContainer: '#f0d060',
    // Button colors — secondary (filled)
    secondary: '#f0d060',
    onSecondary: '#3d3200',
    secondaryLight: '#b8860b',
    onSecondaryLight: '#ffffff',
    // Button colors — inverse
    inverseSurface: '#fffde7',
    onInverseSurface: '#5d5020',
    inverseSurfaceLight: '#2d2a17',
    onInverseSurfaceLight: '#f5efc8',
    // Button colors — label/text
    labelColor: '#f0c040',
    labelColorLight: '#9e7a00',
    // Status colors
    success: '#4caf50',
    successLight: '#81c784',
    successDark: '#2e7d32',
    warning: '#ed6c02',
    warningLight: '#ff9800',
    warningDark: '#e65100',
    error: '#ef5350',
    errorLight: '#ff8a80',
    errorDark: '#c62828',
  },
};

export default yellow;
